<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Pembayaran Piutang</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">/ Penjualan / Pembayaran Piutang</span>
      </div>
    </div>
    <div class="card bg-white">
      <div class="flex justify-content-end mb-2">
        <Button
          icon="pi pi-plus"
          label="Pembayaran"
          class="mr-2"
          @click="$router.push({ name: 'PembayaranPiutangAdd' })"
        />
        <Button
          :loading="isLoadingExport"
          icon="pi pi-file-excel"
          label="Export"
          class="p-button-outlined"
          @click="onExport()"
        />
      </div>
      <grid-pembayaran-piutang
        :items="items"
        :loading="isLoading"
        :total="totalRecords"
        :grid-options="options"
        @request="onRequestData"
        @edit="onEditData"
        @delete="onConfirmDeletion"
        @print="onPrint"
      />
    </div>
    <Dialog
      header="Hapus data pembayaran"
      v-model:visible="dialogHapus"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <span
          >Kontrabon <strong>{{ form.kb_no }}</strong> akan dihapus. Proses
          ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Tutup"
          icon="pi pi-times"
          class="p-button-text mr-2"
          @click="dialogHapus = false"
        />
        <Button
          label="Hapus"
          icon="pi pi-trash"
          class="p-button-text p-button-danger"
          @click="onDeleteData"
        />
      </template>
    </Dialog>
    <Dialog
      :header="pdfTitle"
      v-model:visible="dialogViewer"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '90vw' }"
      :modal="true"
    >
      <div>
        <embed
          :src="pdfSource"
          type="application/pdf"
          width="100%"
          height="600px"
        />
      </div>
      <template #footer>
        <Button
          type="button"
          label="Download"
          icon="pi pi-download"
          class="p-button-text mr-2"
          @click="onDownloadPdf"
        />
        <Button
          type="button"
          label="Print"
          icon="pi pi-print"
          @click="onPrintPdf"
        />
      </template>
    </Dialog>
    <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
  </div>
</template>

<script>
import PiutangService from '@/services/PiutangService'
import GridPembayaranPiutang from '@/components/penjualan/GridPembayaranPiutang'
import errorHandler from '@/helpers/error-handler'
import Hotkey from '@/components/Hotkey'
import { saveAs } from 'file-saver'

export default {
  components: {
    GridPembayaranPiutang,
    Hotkey,
  },
  data() {
    return {
      dataService: null,
      items: [],
      form: {},
      dialogHapus: false,
      isLoading: false,
      isLoadingExport: false,
      dialogViewer: false,
      faktur: 0,
      pdfSource: '',
      pdfTitle: 'PDF Viewer',
      pdfFilename: '',
      totalRecords: 0,
      options: {
        page: 1,
        rows: 10,
        sortField: 'sp_at',
        sortOrder: 1,
        filters: null,
      },
    }
  },
  created() {
    this.dataService = new PiutangService()
  },
  mounted() {
    this.loadGridData()
  },
  methods: {
    onRequestData(e) {
      this.options = e
      this.loadGridData()
    },
    loadGridData() {
      const page = this.options.page
      const perPage = this.options.rows
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      let filters = this.options.filters

      this.isLoading = true
      this.dataService
        .paginate(page, perPage, sortField, sortOrder, filters)
        .then((res) => {
          this.items = res.data.data
          this.totalRecords = res.data.total
          this.isLoading = false

          this.items.forEach((element) => {
            let lastRetur = ''
            let lastIndex = 0
            element.detailNew = []

            for (let index = 0; index < element.detail.length; index++) {
              const data = element.detail[index]

              if (data.sr_no !== '') {
                if (lastRetur !== data.sr_no) {
                  lastRetur = data.sr_no
                  lastIndex = element.detailNew.length
                  element.detailNew.push(data)
                } else {
                  element.detailNew[lastIndex].jumlah_dibayar =
                    element.detailNew[lastIndex].jumlah_dibayar +
                    data.jumlah_dibayar
                }
              } else {
                element.detailNew.push(data)
              }
            }
          })
        })
        .catch((err) => {
          errorHandler(err, 'Data faktur penjualan', this)
        })
        .finally(() => (this.isLoading = false))
    },
    onEditData(data) {
      this.$router.push({
        name: 'PembayaranPiutangEdit',
        params: { id: data.id },
      })
    },
    onConfirmDeletion(data) {
      this.form = data
      this.dialogHapus = true
    },
    onDeleteData() {
      this.dataService
        .delete(this.form.id)
        .then((res) => {
          if (res.data.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Pembayaran Piutang',
              detail: 'Data berhasil dihapus.',
              life: 3000,
            })
            this.loadGridData()
          }
        })
        .catch((err) => {
          errorHandler(err, 'Pembayaran Piutang', this)
        })
      this.form = {}
      this.dialogHapus = false
    },
    onExport() {
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters
      this.isLoadingExport = true
      this.dataService
        .export(sortField, sortOrder, filters)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'pembayaran-piutang-penjualan.xls')
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {
          errorHandler(err, 'Export Data pembayaran piutang', this)
        })
        .finally(() => (this.isLoadingExport = false))
    },
    onPrint(faktur) {
      this.dataService
        .printFaktur(faktur.id)
        .then((res) => {
          if (res.status !== 200) {
            this.$toast.add({
              severity: 'error',
              summary: 'Print faktur',
              detail: 'Gagal mengunduh faktur.',
              life: 3000,
            })
          } else {
            const blob = new Blob([res.data], { type: 'application/pdf' })
            const pdfUrl = URL.createObjectURL(blob)
            this.pdfSource = pdfUrl + '#toolbar=0'
            this.pdfFilename = `faktur-${faktur.sp_no}.pdf`
            this.pdfTitle = 'PDF Viewer (' + this.pdfFilename + ')'
            this.dialogViewer = true
          }
        })
        .catch((err) => {
          errorHandler(err, 'Download faktur', this)
        })
    },
    onPrintPdf() {
      const iframe = document.createElement('iframe')
      iframe.src = this.pdfSource
      iframe.style.display = 'none'
      document.body.appendChild(iframe)

      // Use onload to make pdf preview work on firefox
      iframe.onload = () => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      }
    },
    onDownloadPdf() {
      saveAs(this.pdfSource, this.pdfFilename)
    },
    onTriggerHotkey(payload) {
      if (payload.keyString === 'D') {
        this.$router.push({ name: 'PembayaranPiutangAdd' })
      }
    },
  },
}
</script>
